import axios from 'axios'
const getRequest = async (route, data, headerData) => {

  const get = await axios.get(`${process.env.REACT_APP_API_URL + route}`,
  {headers:headerData}
  )
  return get;
}

export default getRequest;
